import { isEmpty } from 'src/utils/util';


const upperCaseFirstLetter = (str = '') => !isEmpty(str) ? str.replace(/^(.)/, m => m.toUpperCase()) : '';

const species = ({ genus, species, subspecies, variety, family }) => upperCaseFirstLetter(
  [ genus, species, subspecies, variety, family ]
    .join(' ')
    .replace(/ +/g, ' ')
    .trim());


const upperCaseOnlyFirstLetter = string => !isEmpty(string) ? string[0].toUpperCase() + string.slice(1).toLowerCase() : '';

const formatNumber = (value, decimals = 0) => {
  if (typeof value !== 'number') {
    return 'N/D';
  }

  return value.toLocaleString('es-CL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

const formatArea = value => formatNumber(value, 2);

const formatCondition = value => {
  if (!value && value !== 0) {
    return 'N/D';
  }
  return formatNumber(value, 2);
};

const formatAdjustedArea = value => formatNumber(value, 2);

const formatPercentage = value => formatNumber(value, 1);


export {
  upperCaseFirstLetter,
  species,
  upperCaseOnlyFirstLetter,
  formatNumber,
  formatArea,
  formatCondition,
  formatAdjustedArea,
  formatPercentage,
};